export enum ThemeName {
    Casino888 = "casino888",
    Casino888Cip = "casino888/cip",
    Casino888Cis = "casino888/cis",
    Casino777 = "casino777",
    Harrahs = "harrahs",
    Wsop = "wsop",
    WsopCip = "wsop/cip",
    Doverdowns = "doverdowns",
    Delawarepark = "delawarepark",
    Harrington = "harrington"
}
